import React, { useCallback, useContext, useEffect, useState } from 'react';

import { Skeleton } from '@mui/material';

import BdsBanner from '../../../../shared/components/v3/BdsBanner/BdsBanner';
import { CompanyContext } from '../../../../shared/context/company/companyContext';
import { PlansContext } from '../../../../shared/context/plans/plansContext';
import { IBdsBanner } from '../../../../shared/interfaces/bdsBanner';
import { ICompanyBannerResponse } from '../../../../shared/interfaces/company';
import Company from '../../../../shared/services/api/companies/companies';
import { defaultBanner } from '../../../../shared/utils/banner/banner';

const HomeBanner = () => {
  const [onBanners, setOnBanners] = useState<IBdsBanner[] | undefined>(undefined);
  const { companyData, isLoadingCompanyData } = useContext(CompanyContext);
  const { loading: loadingPlans, plans } = useContext(PlansContext);
  const [data, setData] = useState<ICompanyBannerResponse>();
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const isValidCompany = useCallback(() => {
    return companyData && companyData.id !== '' && companyData.locale;
  }, [companyData]);

  const getBanners = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const planProductTypes = Array.from(new Set(plans.map((plan) => plan.type)));
      const response = await Company.getCompanyBanners(companyData.id, planProductTypes);
      if (response) {
        setData(response);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [companyData.id, plans]);

  useEffect(() => {
    if (isValidCompany() && !isLoadingCompanyData && !loadingPlans) {
      getBanners();
    }
  }, [companyData.id, getBanners, isValidCompany, isLoadingCompanyData, loadingPlans]);

  const loadingBanner = useCallback(() => {
    return loading || isLoadingCompanyData || loadingPlans || (!error && !onBanners);
  }, [loading, isLoadingCompanyData, loadingPlans, error, onBanners]);

  const hasBanners = useCallback(() => {
    return onBanners?.length;
  }, [onBanners]);

  const errorLoadingBanners = useCallback(() => {
    return !onBanners?.length && !error;
  }, [onBanners, error]);

  useEffect(() => {
    if (data) {
      setOnBanners(data.banners);
    }
  }, [data]);

  if (loadingBanner()) {
    return (
      <div className="bds-banner-carousel">
        <Skeleton className="skeleton-banner" variant="rectangular" />
      </div>
    );
  }

  if (hasBanners()) {
    return <BdsBanner banners={onBanners} />;
  }

  if (errorLoadingBanners()) {
    return (
      <div className="bds-banner-carousel error">
        <BdsBanner banners={[defaultBanner]} />
      </div>
    );
  }

  return (
    <div className="bds-banner-carousel error">
      <BdsBanner banners={[defaultBanner]} />
    </div>
  );
};

export default HomeBanner;
